import * as types from './schedulingCalendarActionType';

export const fetchSchedulingCalendarRequest = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_REQUEST,
    payload,
});

export const fetchSchedulingCalendarSuccess = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SUCCESS,
    payload,
});

export const fetchSchedulingCalendarFailure = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_FAILURE,
    payload,
});

export const fetchSchedulingCalendarMetadataRequest = () => ({
    type: types.FETCH_SCHEDULING_CALENDAR_METADATA_REQUEST,
});

export const fetchSchedulingCalendarMetadataSuccess = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_METADATA_SUCCESS,
    payload,
});

export const fetchSchedulingCalendarMetadataFailure = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_METADATA_FAILURE,
    payload,
});

export const setSchedulingCalendarView = (payload) => ({
    type: types.SET_SCHEDULING_CALENDAR_VIEW,
    payload,
});

export const setSchedulingCalendarSearch = (payload) => ({
    type: types.SET_SCHEDULING_CALENDAR_SEARCH,
    payload,
});

export const setSchedulingCalendarRange = (payload) => ({
    type: types.SET_SCHEDULING_CALENDAR_RANGE,
    payload,
});

export const setSchedulingCalendarListState = (payload) => ({
    type: types.SET_SCHEDULING_CALENDAR_LIST_STATE,
    payload,
});

export const saveSchedulingCalendarShiftRequest = (payload) => ({
    type: types.SAVE_SCHEDULING_CALENDAR_SHIFT_REQUEST,
    payload,
});

export const saveSchedulingCalendarShiftSuccess = () => ({
    type: types.SAVE_SCHEDULING_CALENDAR_SHIFT_SUCCESS,
});

export const saveSchedulingCalendarShiftFailure = (payload) => ({
    type: types.SAVE_SCHEDULING_CALENDAR_SHIFT_FAILURE,
    payload,
});

export const deleteSchedulingCalendarShiftRequest = (payload) => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHIFT_REQUEST,
    payload,
});

export const deleteSchedulingCalendarShiftSuccess = () => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHIFT_SUCCESS,
});

export const deleteSchedulingCalendarShiftFailure = (payload) => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHIFT_FAILURE,
    payload,
});

export const fetchSchedulingCalendarAdhocDropdownsRequest = () => ({
    type: types.FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_REQUEST,
});

export const fetchSchedulingCalendarAdhocDropdownsSuccess = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_SUCCESS,
    payload,
});

export const fetchSchedulingCalendarAdhocDropdownsFailure = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_ADHOC_DROPDOWNS_FAILURE,
    payload,
});

export const checkSchedulingCalendarAdhocRequest = (payload) => ({
    type: types.CHECK_SCHEDULING_CALENDAR_ADHOC_REQUEST,
    payload,
});

export const checkSchedulingCalendarAdhocSuccess = (payload) => ({
    type: types.CHECK_SCHEDULING_CALENDAR_ADHOC_SUCCESS,
    payload,
});

export const checkSchedulingCalendarAdhocFailure = (payload) => ({
    type: types.CHECK_SCHEDULING_CALENDAR_ADHOC_FAILURE,
    payload,
});

export const saveSchedulingCalendarAdhocRequest = (payload) => ({
    type: types.SAVE_SCHEDULING_CALENDAR_ADHOC_REQUEST,
    payload,
});

export const saveSchedulingCalendarAdhocSuccess = (payload) => ({
    type: types.SAVE_SCHEDULING_CALENDAR_ADHOC_SUCCESS,
    payload,
});

export const saveSchedulingCalendarAdhocFailure = (payload) => ({
    type: types.SAVE_SCHEDULING_CALENDAR_ADHOC_FAILURE,
    payload,
});

export const generateSchedulingCalendarRequest = (payload) => ({
    type: types.GENERATE_SCHEDULING_CALENDAR_REQUEST,
    payload,
});

export const generateSchedulingCalendarSuccess = (payload) => ({
    type: types.GENERATE_SCHEDULING_CALENDAR_SUCCESS,
    payload,
});

export const generateSchedulingCalendarFailure = (payload) => ({
    type: types.GENERATE_SCHEDULING_CALENDAR_FAILURE,
    payload,
});

export const setSchedulingCalendarFilters = (payload) => ({
    type: types.SET_SCHEDULING_CALENDAR_FILTERS,
    payload,
});

export const createSchedulingCalendarSharableLinkRequest = (payload) => ({
    type: types.CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST,
    payload,
});

export const createSchedulingCalendarSharableLinkSuccess = (payload) => ({
    type: types.CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS,
    payload,
});

export const createSchedulingCalendarSharableLinkFailure = (payload) => ({
    type: types.CREATE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE,
    payload,
});

export const sendSchedulingCalendarSharableLinkEmailRequest = (payload) => ({
    type: types.SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_REQUEST,
    payload,
});

export const sendSchedulingCalendarSharableLinkEmailSuccess = (payload) => ({
    type: types.SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_SUCCESS,
    payload,
});

export const sendSchedulingCalendarSharableLinkEmailFailure = (payload) => ({
    type: types.SEND_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_FAILURE,
    payload,
});

export const fetchSchedulingCalendarSharableLinksRequest = () => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_REQUEST,
});

export const fetchSchedulingCalendarSharableLinksSuccess = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_SUCCESS,
    payload,
});

export const fetchSchedulingCalendarSharableLinksFailure = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINKS_FAILURE,
    payload,
});

export const fetchSchedulingCalendarSharableLinkEmailAuditRequest = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_REQUEST,
    payload,
});

export const fetchSchedulingCalendarSharableLinkEmailAuditSuccess = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_SUCCESS,
    payload,
});

export const fetchSchedulingCalendarSharableLinkEmailAuditFailure = (payload) => ({
    type: types.FETCH_SCHEDULING_CALENDAR_SHARABLE_LINK_EMAIL_AUDIT_FAILURE,
    payload,
});

export const deleteSchedulingCalendarSharableLinkRequest = (payload) => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_REQUEST,
    payload,
});

export const deleteSchedulingCalendarSharableLinkSuccess = (payload) => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_SUCCESS,
    payload,
});

export const deleteSchedulingCalendarSharableLinkFailure = (payload) => ({
    type: types.DELETE_SCHEDULING_CALENDAR_SHARABLE_LINK_FAILURE,
    payload,
});

export const updateSchedulingCalendarSharableLinkDateRangeRequest = (payload) => ({ // { request, onSuccess }
    type: types.UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_REQUEST,
    payload,
});

export const updateSchedulingCalendarSharableLinkDateRangeSuccess = (payload) => ({
    type: types.UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_SUCCESS,
    payload,
});

export const updateSchedulingCalendarSharableLinkDateRangeFailure = (payload) => ({
    type: types.UPDATE_SCHEDULING_CALENDAR_SHARABLE_LINK_DATE_RANGE_FAILURE,
    payload,
});

export const clearSchedulingCalendarCreatedSharableLink = () => ({
    type: types.CLEAR_SCHEDULING_CALENDAR_CREATED_SHARABLE_LINK,
});

export const fetchTaskFacilitiesRequest = (payload) => ({ // { owner, taskId, publicContext? }
    type: types.FETCH_TASK_FACILITIES_REQUEST,
    payload,
});

export const fetchTaskFacilitiesSuccess = (payload) => ({ // { owner, taskId, facilities }
    type: types.FETCH_TASK_FACILITIES_SUCCESS,
    payload,
});

export const fetchTaskFacilitiesFailure = (payload) => ({ // { owner, taskId, error }
    type: types.FETCH_TASK_FACILITIES_FAILURE,
    payload,
});

export const clearTaskFacilities = (payload) => ({ // { owner }
    type: types.CLEAR_TASK_FACILITIES,
    payload,
});